<template>
  <div>
    
  </div>
</template>
<script>
export default {
  beforeRouteEnter(to, from, next) {
    next(vm=>{
      if(to.meta.pageParam && to.meta.pageParam.pageType=='openPage'){
        window.open(to.meta.pageParam.pageUrl)
      }else{
        vm.$message.warning('请设置路由参数！')
      }
      vm.$router.push(from.path)
    });
  },
};
</script>